"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemsList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const organisms_1 = require("..");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const parseInfoBoxDescription_1 = require("../../utils/parseInfoBoxDescription");
const ui_1 = require("@completeanatomy/ui");
const models_1 = require("@completeanatomy/models");
const noop_1 = __importDefault(require("lodash/noop"));
function ItemsList({ className, onClick = noop_1.default, onResize, children, items, itemSize, withVideoPlaceholder = false, withSelectedPart = false, }) {
    var _a, _b;
    const selectedPart = (0, models_1.useSelectedPart)();
    const { i18n, t } = (0, i18n_1.useTranslation)();
    const { isMobile } = (0, device_1.usePlatform)();
    const [selectedStructure, setSelectedStructure] = (0, react_1.useState)(selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.name);
    const list = (0, react_1.useMemo)(() => { var _a; return (_a = children !== null && children !== void 0 ? children : items) !== null && _a !== void 0 ? _a : []; }, [children, items]);
    const selectedPartIndex = (_b = (_a = list.find(item => item.isSelected)) === null || _a === void 0 ? void 0 : _a.index) !== null && _b !== void 0 ? _b : -1;
    const selectedPartDescription = (0, react_1.useMemo)(() => ({
        name: selectedStructure
            ? t(i18n_1.Strings.infoBox.structureSelected)
            : t(i18n_1.Strings.infoBox.noStructureSelected),
        text: selectedStructure,
    }), [selectedStructure, t]);
    const stringifiedSelectedPartDescription = JSON.stringify([
        selectedPartDescription,
    ]);
    (0, react_1.useEffect)(() => {
        var _a;
        const updatedPartDescription = ((_a = list === null || list === void 0 ? void 0 : list.find(item => item.isSelected)) === null || _a === void 0 ? void 0 : _a.detail) || '';
        setSelectedStructure(updatedPartDescription);
    }, [list, selectedPartDescription, selectedStructure]);
    const renderCard = (0, react_1.useCallback)((index, ref) => {
        const item = list[index];
        return ((0, jsx_runtime_1.jsx)(organisms_1.ItemCard, Object.assign({}, item, { onClick: e => onClick(index, e), withVideoPlaceholder: withVideoPlaceholder, ref: ref, "data-e2e": 'ItemsList_ItemCard', children: withSelectedPart ? ((0, jsx_runtime_1.jsx)(SelectedPartDescription, { "data-e2e": 'ItemsList_SelectedPartDescription', children: (0, parseInfoBoxDescription_1.parseInfoBoxDescription)(stringifiedSelectedPartDescription, i18n.language) })) : ((item === null || item === void 0 ? void 0 : item.detail) && ((0, jsx_runtime_1.jsx)(Detail, { "data-e2e": 'ItemsList_Detail', children: (0, parseInfoBoxDescription_1.parseInfoBoxDescription)(item.detail, i18n.language) }))) }), index));
    }, [
        list,
        withVideoPlaceholder,
        withSelectedPart,
        stringifiedSelectedPartDescription,
        i18n.language,
        onClick,
    ]);
    const renderFunctions = (0, react_1.useMemo)(() => list.map(() => renderCard), [list, renderCard]);
    return ((0, jsx_runtime_1.jsx)(StyledScrollView, { itemSize: itemSize, "$isMobile": isMobile, selectedIndex: selectedPartIndex, className: className, onResize: onResize, overscan: 20, hasScroll: true, "data-e2e": 'ItemsList_StyledScrollView', children: renderFunctions }));
}
exports.ItemsList = ItemsList;
const StyledScrollView = (0, styled_components_1.default)(ui_1.VirtualScrollView) `
  flex-grow: 1;
  flex-shrink: unset;

  height: 100%;

  padding-right: 8px;

  background-color: ${({ $isMobile, theme }) => $isMobile ? 'none' : theme.backgroundWithOpacity};
`;
const Detail = styled_components_1.default.div `
  flex-shrink: 0;

  font-size: 13px;

  cursor: text;
`;
const SelectedPartDescription = (0, styled_components_1.default)(Detail) `
  padding-left: 10px;
`;
